import { Enum } from "controls";
import { EnStatus } from "./pvdnp/pvdnp-statuses";

export class Utils {
  static trimNameField(s: string): string {
    const res = s.trim()
      .replace(/\s+/g, ' ')
      .replace(/^\s+|\s+$/, '')
      .replace(/\s*[-]+\s*/g, '-')
      .replace(/-+/g, '-');
    return res;
  }

  static trimBirthPlaceField(s: string): string {
    const res = s.trim()
      .replace(/\s+/g, ' ')
      .replace(/^\s+|\s+$/, '')
      .replace(' -', '-')
      .replace('- ', '-');
    return res;
  }

  static dateToDotsFormat(date: Date | null, full: boolean = false): string | null {
    if (date) {
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();
      const day = date.getDate();
      const month = date.getMonth();
      const year = date.getFullYear();

      const shortDate = `${fillZero(day)}.${fillZero(month + 1)}.${year}`;
      const fullDate = `${shortDate} - ${fillZero(hours)}:${fillZero(minutes)}:${fillZero(seconds)}`;

      return full ? fullDate : shortDate;
    } else {
      return null;
    }

    function fillZero(value: number): string {
      return `${(String(value).length === 1 ? '0' : '') + value}`;
    }
  }

  static maskedDateToDotsFormat(maskedDate: string | null) {
    return maskedDate ? maskedDate.split('-').reverse().join('.') : '';
  }

  /**
 * Возвращает для двух строк одну, где права часть как уточение стоит в скобках:
 * например, "Фамилия И.О. (Калининград)"
 * @param leftString строка, которая должна стоять слева без скобок
 * @param rightString строка, которая должна стоять справа в скобках
 */
  static concatWithStringInParenthesis(leftString: string | null | undefined, rightString: string | null | undefined): string {
    const leftSubString = leftString ? leftString : '';
    const rightSubString = leftString && rightString ? `(${rightString})` : '';
    return `${leftSubString} ${rightSubString}`
  }

  static getStatusName(value: string | undefined): string | null {
    return EnStatus.unwrap(new Enum(value));
  }
}
